import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgbModalConfig, NgbDropdownConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { BackOfficeService } from 'src/app/services/back-office/back-office.service';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { RequestService } from 'src/app/services/request/request.service';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';
import { environment } from 'src/environments/environment';
// import { decryptUserData } from '../crypto-js/crypto-js';
import { CryptoService, decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';
import { ClevertapService } from 'src/app/services/clevertap/clevertap.service';
import { HttpParams } from '@angular/common/http';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { AccountService } from 'src/app/services/account/account.service';
import { decrypt } from '../../shared/crypto-js/decrypt';
import { FontResizeService } from 'src/app/services/font-resize/font-resize.service';
import { FinancialProofPendingSubmitService } from 'src/app/services/financial-proof/financial-proof-pending-submit.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  clientId: string = '';
  clientName: string = '';
  clientPan: string = '';
  randomString: string = '';
  dpid: string = '';
  dpAccountNumber: string = '';

  toggleMenu: boolean = false;
  togglePosition: boolean = false;
  toggleAcct: boolean = false;
  brokerageEligible: boolean = false;
  brokerageType: 'new_flow' | 'old_flow' | 'none' = 'none';
  brokerageData: any = null;

  curtainMenu: boolean = false;
  private readonly closeHeaderMenuHandler = () => this.closeNav();

  zerobrokerage: boolean = false;

  headerName: string = '';
  nomineedata: boolean = false;

  isDekycShiftingEligible: boolean = false;
  allowedClientIds: string[] = ['1611482','877922', 'TN3046', '1057815', '760531', 'TN32206', 'RC047', 'PF001'];
  destatClientIds: string[] = ['1611482','877922'];
  showdestatLink: boolean = false;
  showLink: boolean = false;

  feedbackForm = new FormGroup({
    questionOne: new FormControl('', Validators.required),
  })

  @ViewChild("feedbackTemplate", { static: false }) feedbackSurvey: TemplateRef<any>;
  brokerage_plan: any;
  code: any;
  content: boolean;

  constructor(private authService: AuthService,
    private cookies: CookieService,
    private fontService: FontResizeService,
    private dashboardService: DashboardService,
    private router: Router,
    private sweetAlertService: SweetAlertService,
    config: NgbModalConfig,
    dropDownConfig: NgbDropdownConfig,
    private modalService: NgbModal,
    private requestService: RequestService,
    private userDataService: UserDataService,
    private clevertapService: ClevertapService,
    private accountService: AccountService,
    private CryptoService: CryptoService,
    private backOfficeService: BackOfficeService,
    private formBuilder: FormBuilder,
    private financialProofPendingSubmit: FinancialProofPendingSubmitService) {

    config.backdrop = 'static';
    config.keyboard = false;


    dropDownConfig.placement = 'bottom-end';

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        switch (event.url) {
          case '/reports/download':
            this.headerName = 'Download';
            break;
          case '/new-dashboard':
            this.headerName = 'New Dashboard';
            break;
          case '/reports/tax-loss-harvesting':
            this.headerName = 'Tax-Loss Harvesting';
            break;
          case '/reports/tax-pnl':
            this.headerName = 'Tax P & L';
            break;
          case '/reports/pnl':
            this.headerName = 'P & L';
            break;
          case '/reports/trade-book':
            this.headerName = 'Trade Book';
            break;
          case '/portfolio/position':
            this.headerName = 'Position';
            break;
          case '/portfolio/holdings':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/pledge':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/unpledge':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/updateprice':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/family':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/portfolioanalysis/portfolio-summary':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/portfolioanalysis/diversification':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/portfolioanalysis/news':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/holdings/portfolioanalysis/events':
            this.headerName = 'Holdings';
            break;
          case '/portfolio/corporate-action':
            this.headerName = 'Corporate Action';
            break;
          case '/portfolio/tags-analyse':
            this.headerName = 'Tags';
            break;
          case '/calendar/trade-calendar':
            this.headerName = 'Trade Calendar'
            break;
          case '/calendar/economic-calendar':
            this.headerName = 'Economic Calendar';
            break;
          case '/financial-proof':
            this.headerName = 'Income Proof';
            break;
          case '/mt4-subscription':
            this.headerName = 'Mt4 Subscription';
            break;
          case '/brokerage-plan':
            this.headerName = 'Brokerage Plan';
            break;
          case '/mtf':
            this.headerName = 'Margin Trading Facility (MTF)';
            break;
          case '/refer-offers':
            this.headerName = 'Refer & Earn';
            break;
          // case '/f15':
          //   this.headerName = 'F15';
          //   break;
          case '/account-closure':
            this.headerName = 'Account Closure';
            break;
          case '/account/personal':
            this.headerName = 'Account';
            break;
          case '/account/nominee':
            this.headerName = 'Account';
            break;
          case '/account/bank-detail':
            this.headerName = 'Account';
            break;
          case '/account/segment':
            this.headerName = 'Account';
            break;
          case '/account/demat':
            this.headerName = 'Account';
            break;
          case '/account/verified':
            this.headerName = 'Account';
            break;
          case '/account/family':
            this.headerName = 'Account';
            break;
          case '/dashboard':
            this.headerName = 'Dashboard';
            break;
          case '/ledger':
            this.headerName = 'Ledger';
            break;
          case '/trade-journal':
            this.headerName = 'Trader\'s Journal';
            break;
          case '/zero-brokerage':
            this.headerName = 'Zero Brokerage';
            break;
            case '/de-stat':
              this.headerName = 'MF Conversion';
              break;
          default:
            this.headerName = 'BOT';
        }
      }
    })

  }

  ngOnInit(): void {
    window.addEventListener('app:close-header-menu', this.closeHeaderMenuHandler);
    this.getClientData();
    // this.freedomPlan();
    this.getTokenFromCookie();
    this.dekycShiftingEligible();

    const encryptedUserSession = localStorage.getItem('encryptedUserSession');

    if (encryptedUserSession) {
      const decryptedStr = decryptPledgeData(encryptedUserSession);
      const decryptedData = JSON.parse(decryptedStr);
      this.clientId = decryptedData.accountId; 
      this.showLink = this.allowedClientIds.includes(this.clientId);
      this.showdestatLink = this.destatClientIds.includes(this.clientId);
      this.feedbackForm = this.formBuilder.group({
        questionOne: ['', [Validators.required, this.minLengthValidator(25)]]
      });

      if (this.clientId != undefined) {
        this.getNomineeCheck();
      }
      let hasNominee = sessionStorage.getItem('nominee');
      if (hasNominee) {
        this.router.navigate(['/account/nominee']);
      }
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          switch (event.url.split('?')[0]) {
            case '/reports/download':
              this.headerName = 'Download';
              break;
            case '/new-dashboard':
              this.headerName = 'New Dashboard';
              break;
            case '/reports/tax-loss-harvesting':
              this.headerName = 'Tax-Loss Harvesting';
              break;
            case '/reports/tax-pnl':
              this.headerName = 'Tax P & L';
              break;
            case '/reports/pnl':
              this.headerName = 'P & L';
              break;
            case '/reports/trade-book':
              this.headerName = 'Trade Book';
              break;
            case '/portfolio/position':
              this.headerName = 'Position';
              break;
            case '/portfolio/holdings':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/pledge':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/unpledge':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/updateprice':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/family':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/portfolioanalysis/portfolio-summary':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/portfolioanalysis/diversification':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/portfolioanalysis/news':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/holdings/portfolioanalysis/reports':
              this.headerName = 'Holdings';
              break;
            case '/portfolio/corporate-action':
              this.headerName = 'Corporate Action';
              break;
            case '/portfolio/tags-analyse':
              this.headerName = 'Tags';
              break;
            case '/calendar/trade-calendar':
              this.headerName = 'Trade Calendar'
              break;
            case '/calendar/economic-calendar':
              this.headerName = 'Economic Calendar';
              break;
            case '/financial-proof':
              this.headerName = 'Income Proof';
              break;
            case '/mt4-subscription':
              this.headerName = 'Mt4 Subscription';
              break;
            case '/brokerage-plan':
              this.headerName = 'Brokerage Plan';
              break;
            case '/mtf':
              this.headerName = 'Margin Trading Facility (MTF)';
              break;
            case '/refer-offers':
              this.headerName = 'Refer & Earn';
              break;
            // case '/f15':
            //   this.headerName = 'F15';
            //   break;
            case '/account-closure':
              this.headerName = 'Account Closure';
              break;
            case '/account/personal':
              this.headerName = 'Account';
              break;
            case '/account/nominee':
              this.headerName = 'Account';
              break;
            case '/account/bank-detail':
              this.headerName = 'Account';
              break;
            case '/account/segment':
              this.headerName = 'Account';
              break;
            case '/account/demat':
              this.headerName = 'Account';
              break;
            case '/account/verified':
              this.headerName = 'Account';
              break;
            case '/account/family':
              this.headerName = 'Account';
              break;
            case '/dashboard':
              this.headerName = 'Dashboard';
              break;
            case '/ledger':
              this.headerName = 'Ledger';
              break;
            case '/trade-journal':
              this.headerName = 'Trader\'s Journal';
              break;
              case '/de-stat':
                this.headerName = 'MF Conversion';
                break;
            case '/zero-brokerage':
              this.headerName = 'Zero Brokerage';
              break;
            default:
              this.headerName = 'Dashboard';
          }
        }
      })
    }

    // if(sessionStorage.getItem('ddpi')) {
    //   sessionStorage.removeItem('ddpi');
    // }
    // if(sessionStorage.getItem('pledge')) {
    //   sessionStorage.removeItem('pledge');
    // }
    // if(sessionStorage.getItem('family')) {
    //   sessionStorage.removeItem('family');
    // }
    // if(sessionStorage.getItem('account_family')) {
    //   sessionStorage.removeItem('account_family');
    // }
    // if(sessionStorage.getItem('gift-accept')) {
    //   sessionStorage.removeItem('gift-accept');
    // }
    // if(sessionStorage.getItem('holdings')) {
    //   sessionStorage.removeItem('holdings');
    // }
    // if(sessionStorage.getItem('f15')) {
    //   sessionStorage.removeItem('f15');
    // }

    this.checkBrokerageEligible();
    // this.getZerobrokarageStatus();
  }

  increase() { this.fontService.increase(); }
  decrease() { this.fontService.decrease(); }
  reset()    { this.fontService.reset(); }


  loading: boolean = false;

  getClientData() {
    this.loading = true;
    const userDataEncrypted = localStorage.getItem('userData');
    const userDataTime = Number(localStorage.getItem('userDataTime') || '0');
    const now = Date.now();

    const isDataExpired = now - userDataTime > 30 * 60 * 1000;

    if (!userDataEncrypted || isDataExpired) {
      this.userDataService.getUserData().subscribe({
        next: (userData) => {
          this.loading = false;
          if (userData) {
            this.clientName = userData.name;
            this.clientPan = userData.pan;
            this.dpid = userData.dpId;
            this.dpAccountNumber = userData.dpAccountNumber;
          }
        },
        error: () => {
          this.loading = false;
        },
      });
      return;
    }

    const decrypted = decrypt(userDataEncrypted);
    // console.log(decrypted);
    const userData = JSON.parse(decrypted);
    this.loading = false;
    this.clientName = userData.name;
    this.clientPan = userData.pan;
    this.dpid = userData.dpId;
    this.dpAccountNumber = userData.dpAccountNumber;
  }

  dekycShiftingEligible() {
    this.accountService.dekycShiftingEligible().subscribe((response: any) => {
  if (response.status === 'success') {
    const decryptedString = decrypt(response.result);
    // console.log('Decrypted string:', decryptedString);

    try {
      const data = decryptedString ? JSON.parse(decryptedString) : {};
      this.isDekycShiftingEligible = data.dekyc_shifting_eligible || false;
    } catch (error) {
      console.error('Error parsing decrypted data:', error);
      this.isDekycShiftingEligible = false;
    }
  }
});

  }


  getNomineeCheck() {
    if (sessionStorage.getItem('nominee')) {
      this.nomineedata = true;
      this.router.navigate(['/account/nominee']);
    }
    // sessionStorage.setItem('nominee', 'false');
    this.dashboardService.getNomineeDetails().subscribe({
      next: (data) => {
        // console.log(data);
        if (data != null) {
          if (data.status == 'success') {
            if (data.message == 'pending') {
              sessionStorage.setItem('nominee', 'false');
              this.router.navigate(['/account/nominee']);
            }
          }
        }
      }
    })
  }


  // checkBrokerageEligible() {
  //   this.requestService.brokerageEligible().subscribe({
  //     next: (data) => {
  //       if (data == 'brokerage_eligible') {
  //         this.brokerageEligible = true;
  //       }
  //       else if (data == 'brokerage_not_eligible') {
  //         this.brokerageEligible = false;
  //         // this.router.navigate(['/dashboard']);
  //       }
  //       else {
  //         this.brokerageEligible = false;
  //         // this.router.navigate(['/dashboard']);
  //       }
  //     },
  //     error: (err) => {
  //       console.log(err);
  //     }
  //   })
  // }


  checkBrokerageEligible() {
    this.loading = true;
    this.requestService.brokerageEligible().subscribe({
      next: (data) => {
        this.loading = false;
        this.brokerageEligible = false;
        if (data === 'brokerage_eligible') {
          this.brokerageEligible = true;
          this.brokerageType = data.brokerage_type;

          if (data === 'new_flow') {
            this.brokerageData = data.data;
          }
        } else {
          this.brokerageEligible = false;
          this.brokerageType = 'none';
          this.brokerageData = null;
        }
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this.brokerageEligible = false;
        this.brokerageType = 'none';
        this.brokerageData = null;
      },
    });
  }



  taxLossharvesting() {
    // let url = `${environment.copyUrl}/tax-loss-harvesting`;
    // window.open(url);
  }

  clickEvent() {
    this.toggleMenu = !this.toggleMenu;
    this.togglePosition = false;
    this.toggleAcct = false;
    ;
  }

  clickPosition() {
    this.togglePosition = !this.togglePosition;
    this.toggleMenu = false;
    this.toggleAcct = false;

  }

  clickAccount() {
    this.toggleMenu = false;
    this.togglePosition = false;
    this.toggleAcct = !this.toggleAcct;
  }

backOfficeLogin() {

  const newWindow = window.open('', '_blank');

  const params = new HttpParams({
    fromObject: {
      event_name: "BOT - MY ACCOUNT - BACK OFFICE",
    },
  });
  this.clevertapService.pushClevertap(params).subscribe();

  const formData: any = new FormData();
  formData.append('client_code', this.clientId);
  formData.append('client_name', this.clientName);
  formData.append('pan_no', this.clientPan);
  formData.append('random_string', this.makeRandomString());

  this.backOfficeService.submitBackOfficeData(formData).subscribe(
    (data) => {

      for (let [key, value] of formData.entries()) {
        if (key == 'random_string') {
          this.randomString = value;
        }
      }

      const link = `https://bo.aliceblueonline.com/WebClient/index.cfm?ClientCode=${this.clientId}&sessionid=${this.randomString}&reqtype=alice_blue`;

      if (newWindow) {
        newWindow.location.href = link;
      } else {
        window.location.href = link;
      }
    },
    (err) => {
      if (newWindow) newWindow.close();
    }
  );
}

  makeRandomString() {
    let result = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 25; i++) {
      result += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return result;
  }


  async logout() {
    if (
      this.router.url.includes('/financial-proof') &&
      this.financialProofPendingSubmit.isPendingSubmitRequired()
    ) {
      await this.financialProofPendingSubmit.confirmLeaveIfPendingSubmit();
      return;
    }

    const code = localStorage.getItem('login_code'); 

    const params = new HttpParams({
      fromObject: {
        // page: "MY ACCOUNT",
        event_name: "BOT - MY ACCOUNT - LOGOUT",
      },
    });

    this.clevertapService.pushClevertap(params).subscribe();

    this.curtainMenu = false;

   this.authService.logout(code).subscribe({
    next: (res: any) => {
      // console.log('Logout API Response:', res); 

      this.authService.isAuthenticatedSubject.next(false);
      this.authService.clearClientStorage();
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 2000);       
      // this.router.navigate(['/']);
    },
    error: (err) => {
      console.error('logout api error', err);
      this.authService.isAuthenticatedSubject.next(false);
      this.authService.clearClientStorage();
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 2000);
      // this.router.navigate(['/']);
    }
   })
  }


  openNav() {
    const willOpen = !this.curtainMenu;
    this.curtainMenu = willOpen;
    if (willOpen) {
      window.dispatchEvent(new CustomEvent('app:close-account-menu'));
    }
  }

  closeNav() {
    this.curtainMenu = false;
  }

  ngOnDestroy(): void {
    window.removeEventListener('app:close-header-menu', this.closeHeaderMenuHandler);
  }

  getSubmitSurvey() {
    const formData: any = new FormData();
    formData.append('get_survey_data', 'get_survey_data');
    this.dashboardService.aliceServey(formData).subscribe({
      next: (data) => {
        if (data == 'exist') {
          this.sweetAlertService.sweetAlert('success', 'Already Survey Submitted.')
        }
        else if (data == null) {
          this.openFeedbackSurvey();
        }
      }
    })
  }

  openFeedbackSurvey() {
    const params = new HttpParams({
      fromObject: {
        // page: "MY ACCOUNT",
        event_name: "BOT - MY ACCOUNT - FEEDBACK",
      },
    });
    this.clevertapService.pushClevertap(params).subscribe({
      next: (data) => {
      },
      error: (err) => { }
    })
    const dialogRef: NgbModalRef = this.modalService.open(this.feedbackSurvey, { centered: true, size: 'lg', scrollable: true })
    dialogRef.result.then((result) => { console.log("Closed") }, (reason) => { });
  }

  closeDialog() {
    this.modalService.dismissAll();
  }


  minLengthValidator(minLength: number) {
    return (control) => {
      const value = control.value;
      if (value && value.trim().length < minLength) {
        return { minLength: true };
      }
      return null;
    };
  }

  submitSurvey() {
    const formData: any = new FormData();
    formData.append('option1', this.feedbackForm.value.questionOne);
    formData.append('clientName', this.clientName);
    formData.append('surveyFor', 'bot-v2');
    formData.append('submit_survey', 'submit_survey');
    this.dashboardService.aliceServey(formData).subscribe({
      next: (data) => {
        if (data) {
          this.modalService.dismissAll();
          this.feedbackForm.reset();
          this.sweetAlertService.sweetAlert('success', 'Survey Submitted Successfully.')
        }
        else {
          this.modalService.dismissAll();
          this.feedbackForm.reset();
          this.sweetAlertService.sweetAlert('error', 'Something went wrong.')
        }
      }
    })
  }

  freedomPlan() {
    //this.loading = true;
    this.dashboardService.getFreedomPlan(this.clientId).subscribe({
      next: (data) => {
        //this.loading = false;
        if (data) {
          this.brokerage_plan = data.brokerage_plan;
        }
      },
      error: (error) => {
        //this.loading = false;
      }
    })
  }

  getClevertapIPOS() {
    const params = new HttpParams({
      fromObject: {
        // page: "IPO",
        event_name: "BOT - IPO - REDIRECT TO RISE PORTAL",
      },
    });
    this.clevertapService.pushClevertap(params).subscribe({
      next: (data) => {
      },
      error: (err) => { }
    })
  }

  getClevertapSupport() {
    const params = new HttpParams({
      fromObject: {
        // page: "MY ACCOUNT",
        event_name: "BOT - MY ACCOUNT - SUPPORT",
      },
    });
    this.clevertapService.pushClevertap(params).subscribe({
      next: (data) => {
      },
      error: (err) => { }
    })
  }


  // Uat open 

  userPortfolio: any;

  getTokenFromCookie() {

    const encryptedUserSession = localStorage.getItem('encryptedUserSession');

    if (encryptedUserSession) {
      const decryptedStr = decryptPledgeData(encryptedUserSession);
      const decryptedData = JSON.parse(decryptedStr);
      const token = decryptedData.login_token

    if (token) {
      this.content = false;
    } else {
      this.content = true;
    }
   }
  }

  getZerobrokarageStatus() {
    const formData: any = new FormData();
    formData.append('login', 'login');
    this.dashboardService.getZerobrokerageStatus(formData).subscribe(
      (data) => {
        if (data == 'eligible') {
          // console.log('hii')
          this.zerobrokerage = true;
        }
        else {
          this.zerobrokerage = false;
        }
      }
    )
  }

  // Uat close 

}
